import BaseApi from '@/api/Base/BaseApi'
import {
  ChangeWorkspaceOwnerPayload,
  GetWorkspaceListResponse,
  GetWorkspaceMembersResponse,
  MoveUserToWorkspacePayload,
  Workspace
} from '@/api/Workspace/types'

export default class WorkspaceApi extends BaseApi {
  getWorkspaceList() {
    return this.agent.get<GetWorkspaceListResponse>('/workspace/list')
  }

  getWorkspaceMembers(workspaceId: string) {
    return this.agent.get<GetWorkspaceMembersResponse>(`/invitation/workspace/${workspaceId}/list`)
  }

  /** 워크스페이스 오너 강제 변경(위임). 새 오너는 해당 워크스페이스의 기존 멤버여야 함. */
  changeWorkspaceOwner({ workspaceId, newOwnerId }: ChangeWorkspaceOwnerPayload) {
    return this.agent.put<Workspace>(`/admin/workspace/${workspaceId}/owner`, { newOwnerId })
  }

  /** 워크스페이스 간 유저 이동. 응답은 도착지(to) 워크스페이스. */
  moveUserToWorkspace(payload: MoveUserToWorkspacePayload) {
    return this.agent.put<Workspace>('/admin/workspace/move-user', payload)
  }
}
